import Backbone from 'backbone'
import _ from 'underscore'

class Limits extends Backbone.Model {
    url() {
        return '/api/v3/config/limits';
    }

    userLimitReached(users) {
        let limit = this.get('users');
        if (_.isNull(limit)) {
            return false;
        } else {
            return limit <= users.length;
        }
    }

    globalTopicSmtLimitReached() {
        return this.get('global_topics_or_social_media_monitors_reached');
    }
}

export default Limits;
